<template>
  <PaddedContent class="wm_form_row">
    <slot />
  </PaddedContent>
</template>
